import React, {useState} from 'react';

const EditProfile = ({onSave, onCancel, initialData}) => {

  const [editedData, setEditedData] = useState(initialData); 

  const handleInputChange = (e) => {
    setEditedData({
      ...editedData,
      [e.target.name]: e.target.value,
    });
  };

  // using div because there is two buttons, save and cancel 
  return (
    <div className="rounded-lg p-4 shadow-lg max-w-md mx-auto mt-5"style={{ backgroundColor: '#05664f' }}> 
      <h1 className="text-4xl font-extrabold text-white text-center mb-6"style={{ fontFamily: 'Open Sans', textTransform: 'uppercase' }}>Edit Profile</h1>
      <form className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-white">
            Name
            <input
              type="text"
              name="name"
              placeholder='Enter your name here.'
              value={editedData.name}
              onChange={handleInputChange}
              style={{ color: '#0d2329' }}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-d1ff5d focus:border-d1ff5d sm:text-sm"
            />
          </label>
        </div>
        <div>
          <label className="block text-sm font-medium text-white">
            Age
            <input
              type="text"
              name="age"
              placeholder='Enter your age here.'
              value={editedData.age}
              onChange={handleInputChange}
              style={{ color: '#0d2329' }}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-d1ff5d focus:border-d1ff5d sm:text-sm"
            />
          </label>
        </div>
        <div>
          <label className="block text-sm font-medium text-white">
            Gender
            <input
              type="text"
              name="gender"
              placeholder='Enter your gender here.'
              value={editedData.gender}
              onChange={handleInputChange}
              style={{ color: '#0d2329' }}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-d1ff5d focus:border-d1ff5d sm:text-sm"
            />
          </label>
        </div>
        <div>
          <label className="block text-sm font-medium text-white">
            Location
            <input
              type="text"
              name="location"
              placeholder='Enter your location here.'
              value={editedData.location}
              onChange={handleInputChange}
              style={{ color: '#0d2329' }}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-d1ff5d focus:border-d1ff5d sm:text-sm"
            />
          </label>
        </div>
        <div>
          <label className="block text-sm font-medium text-white">
            Personality Type
            <input
              type="text"
              name="personality_type"
              placeholder='Enter your personality here.'
              value={editedData.personality_type}
              onChange={handleInputChange}
              style={{ color: '#0d2329' }}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-d1ff5d focus:border-d1ff5d sm:text-sm"
            />
          </label>
        </div>
        <div className="flex items-center justify-between">
          <button 
            type="button"
            onClick={(e) => onSave(e, editedData)}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            
          >
            SAVE
          </button>
          <button 
            type="button"
            onClick={onCancel}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            CANCEL
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditProfile;